<nav class="ui-catnav ui-catnav--drawer" [ngStyle]="accentVars" aria-label="Product categories">
  <div class="ui-step ui-catnav__head">
    <span class="ui-step__copy">
      <span class="ui-step__title">{{ ProductSideMenu?.MenuTitle || "Categories" }}</span>
      <span class="ui-tag ui-tag--danger" *ngIf="!ProductionEnvironment">test</span>
    </span>
    <button type="button" class="ui-btn ui-btn--ghost ui-btn--sm ui-btn--icon" aria-label="Close" (click)="closeSideCat.emit(false)">×</button>
  </div>

  <div class="ui-catnav__list" id="catnav-drawer">
    <ng-container *ngFor="let category of brand_Categories; trackBy: trackCategory">
      <section
        *ngIf="category?.Status"
        class="ui-card ui-card--step ui-catnav__acc"
        [class.is-selected]="selectedCatId == category.CategoryId"
      >
        <button
          type="button"
          class="ui-step ui-step--toggle"
          [class.collapsed]="selectedCatId != category.CategoryId"
          [attr.aria-expanded]="selectedCatId == category.CategoryId"
          [attr.aria-controls]="'drawer-cat-' + category.CategoryId"
          (click)="selectedCatId == category.CategoryId ? toggleCat(category) : currentComponent != 'store' ? openCat(category, $event) : catCliked(category)"
        >
          <span class="ui-step__copy">
            <span class="ui-step__title">{{ category?.CategoryTitle }}</span>
            <small class="ui-step__hint ui-step__hint--muted" *ngIf="ProductSideMenu?.ShowCounters">
              {{ category.Subcategories?.length || counters?.cats?.[category.CategoryId] || 0 }}
              {{ category.Subcategories?.length ? "groups" : "items" }}
            </small>
          </span>
          <span class="ui-step__chev" *ngIf="category?.Subcategories?.length"
            ><svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 15l6-6 6 6" /></svg
          ></span>
        </button>

        <div
          class="ui-catnav__body collapse"
          *ngIf="category?.Subcategories?.length"
          [id]="'drawer-cat-' + category.CategoryId"
          attr.data-bs-parent="#catnav-drawer"
        >
          <div class="ui-card__body ui-catnav__panel">
          <button
            type="button"
            class="ui-choice ui-choice--chip ui-catnav__chip"
            *ngFor="let subcat of category.Subcategories"
            [class.is-selected]="selectedSubCat == subcat.SubcategoryId"
            (click)="openSubCat(category, subcat, $event)"
          >
            <span class="ui-choice__check" *ngIf="selectedSubCat == subcat.SubcategoryId">✓</span>
            <span class="ui-choice__label">
              {{ subcat?.SubcategoryTitle }}
              <small *ngIf="ProductSideMenu?.ShowCounters && counters?.subCats?.[subcat.SubcategoryId]">{{ counters?.subCats?.[subcat.SubcategoryId] }}</small>
            </span>
          </button>
          </div>
        </div>
      </section>
    </ng-container>
  </div>
</nav>
